import React, { useEffect, useState } from 'react';
import RoomUnderCleaningInfo from './RoomUnderCleaningInfo';
import RenderTimeInfo from './RenderTimeInfo';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import { useSubscription } from '@apollo/client';
import { SUBSCRIBE_DB_EVENT } from '../queries/subscribeDbEvent';
import { setActiveBtn, setCleanTs } from '../state/actions-creators';
import Alert from '@material-ui/lab/Alert';

const mediumFont = 'calc(1px + 2.5vmin)';

const CleaningInfoDiv = styled.div`
  margin-top: 3vh;
`;

const AreaText = styled.p`
  font-size: ${mediumFont};
  font-weight: bold;
  margin-top: 2vh;
`;

const ProgressText = styled.span`
  font-size: ${mediumFont};
  font-weight: 500;
  margin-top: 0vh;
  margin-left: 0vh;
`;

const CleaningStatus = styled.div`
  font-size: ${mediumFont};
  margin-top: 5vh;
`;

const RoomUnderCleaningApp = () => {
  const { area, cleaningAreas } = useSelector((state) => state);
  const dispatch = useDispatch();
  // Initialize loading based on area validity
  const [isLoading, setIsLoading] = useState(!area);
  const [error, setError] = useState('');

  const isValidArea = Boolean(area && area.trim().length > 0);

  const params = new URL(document.location).searchParams;
  const pathIds = window.location.pathname.split('/');
  const orgId = params.get('organization') || pathIds[1];
  const locationId = params.get('location') || pathIds[2];

  const { error: subscriptionError, data } = useSubscription(SUBSCRIBE_DB_EVENT, {
    variables: {
      eb_organization_id: orgId,
      eb_location_id: locationId,
      area: area,
    },
    skip: !isValidArea,
  });

  // Set loading when subscription starts
  useEffect(() => {
    if (isValidArea && !data) {
      setIsLoading(true);
    }
  }, [isValidArea, data]);

  // Handle subscription errors
  useEffect(() => {
    if (subscriptionError) {
      console.log('Subscription Error: ');
      console.log(subscriptionError);
      setError('Failed to connect to cleaning service');
    }
  }, [subscriptionError]);

  useEffect(() => {
    if (data) {
      const updateApp = async () => {
        if (data?.events.length === 0) {
          dispatch(setCleanTs('Never'));
          dispatch(setActiveBtn('start'));
        } else if (data?.events) {
          dispatch(setCleanTs(data.events[0].ts));
          if (data.events[0].type === 'start') {
            dispatch(setActiveBtn('stop'));
          } else {
            dispatch(setActiveBtn('start'));
          }
        }
      };
      updateApp();
      setIsLoading(false);
    }
  }, [data, dispatch]);

  // Show error immediately if area is invalid
  if (!isValidArea) {
    return (
      <>
        <AreaText>
          Chosen area: <ProgressText>Not Set</ProgressText>
        </AreaText>
        <Alert severity="error" style={{ marginTop: '1rem', whiteSpace: 'pre-line' }}>
          {'Name is required.\nPlease inform your superior quickly about missing name.\nAlueen nimi puuttuu. Ilmoita asiasta pikaisesti esihenkillöllesi.'}
        </Alert>
      </>
    );
  }

  // Only show loading if we're waiting for valid area data
  if (isLoading && isValidArea) {
    return <AreaText>Loading...</AreaText>;
  }

  return (
    <>
      <AreaText>
        Chosen area: <ProgressText>{area}</ProgressText>
      </AreaText>
      {error ? (
        <Alert severity="error" style={{ marginTop: '1rem' }}>
          {error}
        </Alert>
      ) : (
        <>
          <AreaText>
            Cleaning in progress:{' '}
            <ProgressText>
              {cleaningAreas.length !== 0
                ? cleaningAreas.map((area, index) => {
                    if (index === 0) {
                      return area;
                    } else {
                      return ', ' + area;
                    }
                  })
                : '-'}
            </ProgressText>
          </AreaText>
          <CleaningInfoDiv>
            <RoomUnderCleaningInfo/>
            <CleaningStatus>
              <RenderTimeInfo />
            </CleaningStatus>
          </CleaningInfoDiv>
        </>
      )}
    </>
  );
};

export default RoomUnderCleaningApp;
